import { Feedback, FeedbackLabelType } from 'v2/core/entities/feedback';

export const updateFeedbacks = (
  records?: Feedback[],
): Feedback[] | undefined => {
  return filterOutClusters(records);
};

const filterOutClusters = (records?: Feedback[]): Feedback[] | undefined => {
  return records?.map((record) => ({
    ...record,
    labels: record.labels?.filter((l) => l.type !== FeedbackLabelType.Cluster),
  }));
};
